export default __webpack_public_path__ + "static/media/ISSO CLASS-7 EXAM PATTERN 2026-27.065ab127.pdf";